export const PUBLIC_LINK_GENERIC_ERROR =
  'Não foi possível abrir este link. Peça um novo à equipe.';

const SENSITIVE_PUBLIC_LINK_ERROR_PATTERN = /token inválido|aluna inativa/i;

export const sanitizePublicLinkError = (message?: string | null): string => {
  const normalized = message?.trim() ?? '';

  if (!normalized || SENSITIVE_PUBLIC_LINK_ERROR_PATTERN.test(normalized)) {
    return PUBLIC_LINK_GENERIC_ERROR;
  }

  return normalized;
};
